import type { ReactNode } from 'react'
import { apiAssetUrl } from '../../config'

export type CaseStudyRow = {
  id: number
  title: string
  slug: string
  summary: string | null
  client_name?: string | null
  industry?: string | null
  cover_image_path?: string | null
  cover_stored_path?: string | null
  is_published: number
  is_active?: number
  sort_order?: number
  published_at: string | null
  updated_at?: string | null
}

export type CaseStudyDetail = CaseStudyRow & {
  content_html: string
  conversion_rate?: string | null
  average_ticket_size?: string | null
  total_site_visits?: string | null
  campaign_duration?: string | null
  active_pipeline_value?: string | null
  services_delivered?: string | null
  seo_title?: string | null
  seo_description?: string | null
  seo_keywords?: string | null
  focus_keyword?: string | null
  secondary_keywords?: string | null
  canonical_path?: string | null
  og_title?: string | null
  og_description?: string | null
  og_image_path?: string | null
  schema_type?: string | null
  noindex?: number | boolean | null
  nofollow?: number | boolean | null
  exclude_from_sitemap?: number | boolean | null
  ai_summary?: string | null
  key_takeaways?: string | null
  faq_json?: string | null
  how_to_json?: string | null
  related_queries?: string | null
  search_intent?: string | null
  author_name?: string | null
  author_role?: string | null
  target_locations?: string | null
  primary_city?: string | null
  service_area?: string | null
  breadcrumb_label?: string | null
  reviewed_at?: string | null
}

export function formatDate(v: string | null | undefined) {
  if (!v) return '—'
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return String(v).slice(0, 10)
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
}

export function StatusBadge({ published }: { published: boolean }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[0.7rem] font-bold uppercase tracking-wide ${
        published ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-600'
      }`}
    >
      {published ? 'Published' : 'Draft'}
    </span>
  )
}

export function CoverThumb({ path }: { path?: string | null }) {
  if (!path) {
    return <div className="h-11 w-11 shrink-0 rounded-xl bg-primary/10 border border-primary/10" />
  }
  return (
    <img
      src={apiAssetUrl(path)}
      alt=""
      className="h-11 w-11 shrink-0 rounded-xl object-cover border border-primary/10 bg-slate-100"
    />
  )
}

export function IconAction({
  children,
  label,
  onClick,
  danger,
}: {
  children: ReactNode
  label: string
  onClick: () => void
  danger?: boolean
}) {
  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      onClick={onClick}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-xl border transition active:scale-95 ${
        danger
          ? 'border-red-200 bg-red-50 text-red-600 hover:bg-red-100'
          : 'border-primary/15 bg-white text-primary hover:bg-primary/[0.06]'
      }`}
    >
      {children}
    </button>
  )
}
